module.exports = __webpack_public_path__ + "static/media/MATIC-USDT.ec85069b.png";